import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatTableModule } from "@angular/material/table";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { MixDesignRoutingModule } from "./mix-design-routing.module";
import { MixDesignSearchResultComponent } from "./mix-design-search-result/mix-design-search-result.component";
import { MatCardModule } from "@angular/material/card";
import { MatTabsModule } from "@angular/material/tabs";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MixDesignDashboardComponent } from "./mix-design-dashboard/mix-design-dashboard.component";
import { MatDividerModule } from "@angular/material/divider";
import { AddEditMixDesignComponent } from "./add-edit-mix-design/add-edit-mix-design.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { GeothermMixDesignComponent } from "./geotherm-mix-design/geotherm-mix-design.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { BaseChartDirective } from "ng2-charts";
import { StrengthChartComponent } from "./models/strength-chart/strength-chart.component";

@NgModule({
  declarations: [
    MixDesignSearchResultComponent,
    AddEditMixDesignComponent,
    MixDesignDashboardComponent,
    GeothermMixDesignComponent,
    StrengthChartComponent
  ],
  imports: [
    MixDesignRoutingModule,
    MatDatepickerModule,
    CommonModule,
    MatTableModule,
    MatCheckboxModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTabsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDividerModule,
    MatAutocompleteModule,
    BaseChartDirective
  ]
})
export class MixDesignModule { }
